module.exports = window["__sharedReactDOM"];